import { Box } from '@mui/material'
import { resolveChatResponseBlock } from '../blockRegistry'
import { blockKey } from './blockKey'
import { useEnteredBlockKeys } from './useEnteredBlockKeys'
import styles from './BlockRenderer.module.scss'

/**
 * @param {{
 *   blocks: Array<{ type: string }>,
 *   citations?: Array<{ marker: number }>,
 *   onAgentQuestionSelect?: (optionId: string) => void,
 *   streaming?: boolean,
 *   animateEnter?: boolean,
 * }} props
 */
const BlockRenderer = ({
  blocks,
  citations = [],
  onAgentQuestionSelect,
  streaming = false,
  animateEnter = streaming,
}) => {
  const entered = useEnteredBlockKeys(blocks, animateEnter)
  if (!blocks || !Array.isArray(blocks)) return null
  const lastBlockIndex = blocks.length - 1

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
      {blocks.map((block, i) => {
        const Renderer = resolveChatResponseBlock(block.type)
        if (!Renderer) return null
        const key = blockKey(block, i)
        const content = Renderer({
          block,
          i,
          citations,
          onAgentQuestionSelect,
          streaming: streaming && i === lastBlockIndex,
        })
        return content ? (
          <Box
            key={key}
            className={entered.has(key) ? styles.streamBlock : undefined}
            sx={{ width: '100%' }}
          >
            {content}
          </Box>
        ) : null
      })}
    </Box>
  )
}

export default BlockRenderer
